import { useEffect, useState } from 'react'

import * as canIUse from '$extensionSrc/utils/canIUse'
import * as communication from '$extensionSrc/utils/communication'

async function getActiveTabLanguage(
  tabId: number,
  isSidePanel: boolean,
): Promise<string | null | undefined> {
  let activeTabLanguage: string
  if (isSidePanel) {
    const response = await communication.getActiveTabLanguageRequestToTab(tabId)
    activeTabLanguage = response?.activeTabLanguage
  } else {
    activeTabLanguage =
      await communication.getActiveTabLanguageRequestToBackground()
  }

  if (activeTabLanguage === undefined) {
    return null
  }
  return activeTabLanguage
}

export function useActiveTabLanguage(
  currentTab: chrome.tabs.Tab | undefined,
  isSidePanel: boolean,
): string | null | undefined {
  const [activeTabLanguage, setActiveTabLanguage] = useState<
    string | null | undefined
  >()

  const activeTabId = currentTab?.id
  const activeTabUrl = currentTab?.url
  const activeTabStatus = currentTab?.status

  useEffect(() => {
    const load = async () => {
      const aTL = await getActiveTabLanguage(activeTabId, isSidePanel)
      setActiveTabLanguage(aTL)
    }
    /**
     * If in the side panel, we need to check if the active tab is completely loaded
     * (some pages load language into the HTML later); rely on the `currentTab` being
     * updated whenever anything changes.
     *
     * Injected-into-dom components are only injected once page is loaded and can't
     * access the chrome.tabs API, so we don't check for status in their case.
     */
    if (
      !isSidePanel ||
      (canIUse.chromeTabs() &&
        activeTabStatus === chrome.tabs.TabStatus.COMPLETE)
    ) {
      load()
    }
  }, [activeTabId, activeTabStatus, activeTabUrl, isSidePanel])

  return activeTabLanguage
}
